import React from 'react';
import autobind from "autobind-decorator";
import moment from "moment-jalaali";

import { PureComponent, Serialize, Description, GroupBox } from 'core/components';
import { CardContent, List, ListItem, Popover, Block, Row, Col, Icon } from 'core/components/Framework7';
import { CartProduct } from 'content/components';

import classes from './styles.module.css';

const Price = Serialize.Price;

class OrderProduct extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      sheetOpened: false
    }
  }

  get initialValue() {
    return this.parseOrder()
  }

  get status() {
    return {
      0: { name: "Canceled", title: "لغو شده", color: "var(--order-step-canceled)", key: 0 },
      20: { name: "Registered", title: "ثبت شده", color: "var(--order-step-registered)", key: 20 },
      30: { name: "Seen", title: "مشاهده شده", color: "var(--order-step-seen)", key: 30 },
      40: { name: "Modified", title: "اعمال تغییرات در سفارش", color: "var(--order-step-modified)", key: 40 },
      50: { name: "Accepted", title: "تأیید شده", color: "var(--order-step-accepted)", key: 50 },
      60: { name: "SentToStock", title: "تحویل انبار", color: "var(--order-step-sent-to-stock)", key: 60 },
      70: { name: "StockModified", title: "تغییر کالا در انبار", color: "var(--order-step-stock-modified)", key: 70 },
      80: { name: "StockAccepted", title: "تأیید انبار", color: "var(--order-step-stock-accepted)", key: 80 },
      90: { name: "CourierSelected", title: "تحویل به پیک", color: "var(--order-step-courier-selected)", key: 90 },
      100: { name: "Sent", title: "ارسال شده", color: "var(--order-step-sent)", key: 100 },
      130: { name: "Delivered", title: "تحویل شده", color: "var(--order-step-delivered)", key: 130 },
      140: { name: "Completed", title: "تحویل شده", color: "var(--order-step-completed)", key: 140 },
      500: {name: "NotFound", title: "در دست بررسی", color: "var(--f7-theme-color)", key: 500},
    }
  }

  parseOrder() {
    const { item } = this.props;

    return {
      id: item ? item.id : 0,
      status: item.status,
      stepStatus: this.status[item.status == 20 ? 0 : (item.steps && item.steps.length > 0 && item.steps[0].status || 500)] || this.status[500],
      recipient: item ? item.shippingInfo ? item.shippingInfo.recipient : '' : '',
      phone: item ? item.shippingInfo ? item.shippingInfo.phone : '' : '',
      titleAddress: item ? item.shippingInfo ? item.shippingInfo.address ? item.shippingInfo.address.title : '' : '' : '',
      textAddress: item ? item.shippingInfo ? item.shippingInfo.address ? item.shippingInfo.address.text : '' : '' : '',
      paymentMethodTitle: item ? item.billingInfo ? item.billingInfo.method ? item.billingInfo.method.title : '' : '' : '',
      price: item ? item.finalPrice : 0,
      cart: item ? item.cart : [],
      giftId: item ? item.giftId : 0,
      trackingCode: item.trackingCode,
      createdAt: item.createdAt,
      updatedAt: item.updatedAt,
    }
  }

  parsePrice() {
    const { price } = this.props;

    return {
      sumAfter: price ? price.sumAfter : 0,
      sumBefore: price ? price.sumBefore : 0,
      sumOfDiscounts: price ? price.sumOfDiscounts : 0,
    }
  }

  render() {
    const order = this.initialValue;
    const price = this.parsePrice();

    // console.log('order:', order)

    return (
      <React.Fragment>
        <GroupBox title={'اطلاعات گیرنده'} outline>
          <CardContent>
            <List mediaList>
              <ListItem>
                <div slot='title'>
                  <Row className={classes.trackinCodeTitle}>
                    {'شماره پیگیری'}
                  </Row>
                  <Row>
                    <span className={classes.trackingCodeText}>
                      {order.trackingCode}
                    </span>
                  </Row>
                </div>
                <span slot='after' style={{ color: order.stepStatus.color }}>
                  {order.stepStatus.title}
                </span>
                {/* icon */}
                <Icon
                  slot="media"
                  icon="mdi-receipt"
                  style={{ color: order.stepStatus.color }}
                />
                {/* content */}
                <Row className={classes.orderContentItem}>
                  <Col width="50">
                    {moment(order.updatedAt).format("HH:mm jYYYY/jMM/jDD")}
                  </Col>
                  <Col width="50" className={classes.priceBox}>
                    <Price price={order.price} />
                  </Col>
                </Row>
              </ListItem>
              <ListItem
                header={'تحویل گیرنده'}
                title={order ? order.recipient : ""}
              />
              <ListItem
                header={'شماره تماس'}
                title={order ? order.phone : ""}
              />
              <ListItem
                header={'عنوان مقصد'}
                title={order ? order.titleAddress : ''}
              />
              <ListItem
                header={'آدرس مقصد'}
                title={order ? order.textAddress : ''}
                link="#"
                popoverOpen=".popover-address"
              />
              <ListItem
                header={'نحوه پرداخت'}
                title={order ? order.paymentMethodTitle : ''}
              />
            </List>
          </CardContent>
        </GroupBox>

        <CartProduct
          items={order ? order.cart : []}
          readOnly={true}
        />

        <Description
          sumBefore={price && price.sumBefore}
          sumOfDiscounts={price && price.sumOfDiscounts}
          sumAfter={price && price.sumAfter}
          gift={order && order.giftId && order.gift && order.gift.value}
        />

        <Popover className="popover-address">
          <Block>
            <p>
              {order ? order.textAddress : ''}
            </p>
          </Block>
        </Popover>
      </React.Fragment>
    )
  }
}

export default autobind(OrderProduct);
